export default "__VITE_ASSET__lTK1jOgr__"